import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Next({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-1.5 -1.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
      transform={props.transform}
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g className={theme.stroke} fill="none" fillRule="evenodd">
        <path d="M18.4329057 1.47104717c-9.49292457 0-17.19820759 7.70462264-17.19820759 17.19820753 0 9.4935849 7.70528302 17.1982076 17.19820759 17.1982076 9.4935849 0 17.1982075-7.7046227 17.1982075-17.1982076 0-9.49358489-7.7046226-17.19820753-17.1982075-17.19820753z" />
        <path d="M28.658783 18.6692547L18.1006698 29.2273679v-6.7186792h-8.03415093v-7.6782076h8.03415093V8.11114151z" />
      </g>
    </svg>
  )
}

Next.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  transform: PropTypes.string,
}
